var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"padding":"0","min-height":"100vh"},attrs:{"fluid":""}},[(!_vm.lg)?[_c('chatbox')]:_vm._e(),(_vm.lg)?[_c('ChatboxLG')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }